module.exports = __webpack_public_path__ + "img/check.cb4a5150.svg";